export default "__VITE_ASSET__5fb1701c__"